import { useState, useEffect, useRef } from "react";
import ProductCard from "./ProductCard";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ChevronLeftOutlinedIcon from "@material-ui/icons/ChevronLeftOutlined";
import ChevronRightOutlinedIcon from "@material-ui/icons/ChevronRightOutlined";

function HomeProduct(props) {
  const history = useNavigate();
  const { t } = useTranslation();
  const { title, langs, remove, isLocal } = props;
  const [mainL, setMainL] = useState("en-US");
  const [showp, setShowp] = useState(false);
  const theme = JSON.parse(localStorage.getItem("machine"))?.themeColor;
  const ref = useRef(null);

  const [showL, setShowL] = useState(true);
  const [showR, setShowR] = useState(true);

  useEffect(() => {
    const mycoockie = Cookies.get("i18next");
    if (mycoockie === "fr") {
      setMainL("fr-CA");
    } else if (mycoockie === "es") {
      setMainL("es-US");
    }
  }, []);

  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };

  const runState = () => {
    if (ref) {
      setShowL(ref.current.scrollLeft === 0);
      setShowR(
        !(
          ref.current.scrollLeft <
          ref.current.scrollWidth - ref.current.clientWidth
        )
      );
    }
  };

  const handleScroll = () => {
    runState();
  };

  useEffect(() => {
    runState();
  }, []);

  useEffect(() => {
    if (ref) {
      ref.current?.addEventListener("scroll", handleScroll, { passive: true });

      return () => {
        ref.current?.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  let result = JSON.parse(localStorage.getItem("bestSeller"));
  let symbol = JSON.parse(localStorage.getItem("machine"))?.currency?.symbol;
  let machineID = JSON.parse(localStorage.getItem("machine"))?._id;
  symbol = symbol ? symbol : "$";

  const products = result.map((prod, i) => {
    // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
    const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
    return (
      <ProductCard
        remove={remove}
        langs={langs}
        mainL={mainL}
        symbol={symbol}
        setShowp={setShowp}
        cart={props.cart}
        alterquantity={props.alterquantity}
        add={props.add}
        decreStock={props.decreStock}
        prod={prod}
        image={url}
        key={i}
        twoLine={true}
        machineID={machineID}
      />
    );
  });

  let row1 = [];
  let row2 = [];

  if (theme?.b_column === "1" && theme?.c_column === "1") {
    row1 = products;
  } else {
    for (let i = 1; i <= products.length; i++) {
      if (i % 2 === 1) {
        row1.push(products[i - 1]);
      }
      if (i % 2 === 0) {
        row2.push(products[i - 1]);
      }
    }
  }

  return (
    <div className="homeProduct" style={{ marginBottom: "30px" }}>
      <h1 className="homeProductText"> {t(`Best Seller`)}</h1>
      {/* <div className="home-product-container d-flex">{products}</div> */}
      <div className="d-flex align-items-center">
        <div>
          <div style={{ width: "50px" }}>
            <ChevronLeftOutlinedIcon
              hidden={showL}
              className="home-page-arrow-icon mr-2"
              onClick={() => scroll(-100)}
            />
          </div>
        </div>
        <div className="home-product-container" ref={ref}>
          <div className="home-products-div">
            <div className="home-products">{row1}</div>
            {row2?.length > 0 && (
              <div className="home-products mb-5">{row2}</div>
            )}
          </div>
        </div>
        <div>
          <div style={{ width: "50px" }}>
            <ChevronRightOutlinedIcon
              hidden={showR}
              className="home-page-arrow-icon ml-2"
              onClick={() => scroll(100)}
            />
          </div>
        </div>
      </div>

      <div>
        {/* <div className="view-more-button" onClick={goToALLProducts}>
          {t('VIEW MORE')}
        </div> */}
      </div>
    </div>
  );
}
export default HomeProduct;
